export function autosuggestions() {
	const suggestionsElements = document.querySelectorAll(".js-auto-suggestions");
	const htmlElement = document.documentElement;

	if (!suggestionsElements.length) return;

	const testSuggestions = [
		"Apple",
		"Banana",
		"Cherry",
		"Date",
		"Elderberry",
		"Fig",
		"Grape",
		"Search term labore et dolore magna aliqua",
		"Search term sed do eiusmod",
	];

	const useTestData = false; // set false before commit

	suggestionsElements.forEach((inputElement, index) => {
		const autocompleteId = getAutocompleteId(inputElement, index);

		inputElement.setAttribute("aria-controls", autocompleteId);
		inputElement.setAttribute("aria-autocomplete", "list");

		if (inputElement.getAttribute("type") !== "search") {
			inputElement.setAttribute("type", "search");
		}

		inputElement.addEventListener("input", () => {
			const inputValue = inputElement.value.trim();

			if (inputValue.length > 0) {
				if (useTestData) {
					const filteredSuggestions = testSuggestions.filter((item) =>
						item.toLowerCase().includes(inputValue.toLowerCase()),
					);

					if (filteredSuggestions.length) {
						const suggestionsMarkup = generateSuggestionsMarkup(
							filteredSuggestions,
							inputValue,
							autocompleteId,
						);
						addSuggestionsMarkup(inputElement, suggestionsMarkup);
					} else {
						removeSuggestions(inputElement);
					}
				} else {
					const pageId = inputElement.getAttribute("data-search-pageid");
					const useraffle = inputElement.getAttribute("data-useraffle");
					const lang = htmlElement.getAttribute("lang") || "da";

					const apiUrl =
						"/api/search/GetTypeAhead?searchTerm=" +
						encodeURIComponent(inputValue) +
						"&pageId=" +
						encodeURIComponent(pageId || "") +
						"&lang=" +
						encodeURIComponent(lang) +
						"&useRaffle=" +
						encodeURIComponent(useraffle || "False");

					fetch(apiUrl, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
						},
					})
						.then((response) => response.json())
						.then((data) => {
							if (Array.isArray(data) && data.length) {
								const suggestionsMarkup = generateSuggestionsMarkup(
									data,
									inputValue,
									autocompleteId,
								);
								addSuggestionsMarkup(inputElement, suggestionsMarkup);
							} else {
								removeSuggestions(inputElement);
							}
						})
						.catch((error) => {
							console.error("Error:", error);
							removeSuggestions(inputElement);
						});
				}
			} else {
				removeSuggestions(inputElement);
			}
		});

		inputElement.addEventListener("focus", () => {
			if (inputElement.value.trim().length === 0 && !useTestData) {
				AddTopSuggestions(inputElement, autocompleteId);
			}
		});

		inputElement.addEventListener("blur", () => {
			setTimeout(() => {
				removeSuggestions(inputElement);
			}, 200);
		});

		inputElement.addEventListener("keydown", (event) => {
			const searchBar = getSearchBarContainer(inputElement);
			const suggestionsContainer = searchBar?.querySelector(
				".suggestions--autocomplete [role='listbox']",
			);

			if (!suggestionsContainer) return;

			const items = suggestionsContainer.querySelectorAll("li[role='option']");
			let currentIndex = Array.from(items).findIndex((item) =>
				item.classList.contains("highlighted"),
			);

			if (event.key === "ArrowDown") {
				event.preventDefault();
				currentIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
				highlightItem(items, currentIndex, inputElement);
			} else if (event.key === "ArrowUp") {
				event.preventDefault();
				currentIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
				highlightItem(items, currentIndex, inputElement);
			} else if (event.key === "Enter") {
				const closestForm = inputElement.closest("form");

				if (currentIndex > -1) {
					event.preventDefault();
					const selectedItem = items[currentIndex];
					inputElement.value =
						selectedItem.dataset.query || selectedItem.innerText.trim();
					removeSuggestions(inputElement);

					if (closestForm) {
						closestForm.submit();
					}
				}
			} else if (event.key === "Escape") {
				removeSuggestions(inputElement);
			}
		});
	});

	function getSearchBarContainer(inputElement) {
		return (
			inputElement.closest(".search-bar--small, .search-bar") ||
			inputElement.closest("form")?.parentElement
		);
	}

	function getAutocompleteId(inputElement, index) {
		const baseId =
			inputElement.id && inputElement.id.trim() !== ""
				? `${inputElement.id}-${index}`
				: `search-input-${index}`;

		return `${baseId}-autocomplete-list`;
	}

	function escapeRegExp(string) {
		return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}

	function generateSuggestionsMarkup(suggestions, searchTerm, autocompleteId) {
		const safeSearchTerm = escapeRegExp(searchTerm);
		const searchTermRegex = new RegExp(`(${safeSearchTerm})`, "gi");
		const headingId = `${autocompleteId}-label`;

		let markup = '<div class="suggestions--autocomplete active">';
		markup += `<h2 id="${headingId}" class="h5">Forslag</h2>`;
		markup += `<ul id="${autocompleteId}" role="listbox" aria-labelledby="${headingId}">`;

		suggestions.forEach((suggestion, index) => {
			const suggestionText =
				typeof suggestion === "string"
					? suggestion
					: suggestion.text || suggestion.query || "";

			const queryValue =
				typeof suggestion === "string"
					? suggestion
					: suggestion.query || suggestion.text || "";

			const optionId = `${autocompleteId}-option-${index}`;

			const highlightedSuggestion = suggestionText.replace(
				searchTermRegex,
				"<strong>$1</strong>",
			);

			markup += `
				<li
					id="${optionId}"
					role="option"
					aria-selected="false"
					tabindex="-1"
					data-query="${escapeHtml(queryValue)}"
				>
					<span>${highlightedSuggestion}</span>
				</li>
			`;
		});

		markup += "</ul></div>";
		return markup;
	}

	function addSuggestionsMarkup(inputElement, markup) {
		const formElement = inputElement.closest("form");
		const searchBar = getSearchBarContainer(inputElement);

		if (!formElement || !searchBar) return;

		removeSuggestions(inputElement);

		formElement.insertAdjacentHTML("afterend", markup);
		inputElement.setAttribute("aria-expanded", "true");

		const suggestionItems = searchBar.querySelectorAll(
			".suggestions--autocomplete li[role='option']",
		);

		suggestionItems.forEach((item) => {
			item.addEventListener("click", () => {
				inputElement.value = item.dataset.query || item.innerText.trim();
				removeSuggestions(inputElement);

				const closestForm = inputElement.closest("form");
				if (closestForm) {
					closestForm.submit();
				}
			});
		});
	}

	function removeSuggestions(inputElement) {
		const searchBar = getSearchBarContainer(inputElement);
		if (!searchBar) return;

		const existingSuggestions = searchBar.querySelector(
			".suggestions--autocomplete",
		);

		if (existingSuggestions) {
			existingSuggestions.remove();
		}

		inputElement.setAttribute("aria-expanded", "false");
		inputElement.removeAttribute("aria-activedescendant");
	}

	function highlightItem(items, index, inputElement) {
		items.forEach((item, idx) => {
			if (idx === index) {
				item.classList.add("highlighted");
				item.setAttribute("aria-selected", "true");
				item.scrollIntoView({ block: "nearest" });

				if (inputElement && item.id) {
					inputElement.setAttribute("aria-activedescendant", item.id);
				}
			} else {
				item.classList.remove("highlighted");
				item.setAttribute("aria-selected", "false");
			}
		});
	}

	function generateTopquestionsMarkup(topQuestions, autocompleteId) {
		const headingId = `${autocompleteId}-label`;

		let markup = '<div class="suggestions--autocomplete active">';
		markup += `<h2 id="${headingId}" class="h5">${topQuestions.title}</h2>`;
		markup += `<ul id="${autocompleteId}" role="listbox" aria-labelledby="${headingId}">`;

		topQuestions.questions.forEach((question, index) => {
			const logo = question.logo || "";
			const optionId = `${autocompleteId}-option-${index}`;

			markup += `
				<li
					id="${optionId}"
					class="${logo ? "has-icon" : ""}"
					role="option"
					aria-selected="false"
					tabindex="-1"
					data-query="${escapeHtml(question.query)}"
				>
					${logo ? `<span class="${logo}"></span>` : ""}
					<span>${question.text}</span>
				</li>
			`;
		});

		markup += "</ul></div>";
		return markup;
	}

	function AddTopSuggestions(inputElement, autocompleteId) {
		const pageId = inputElement.getAttribute("data-search-pageid");
		const useraffle = inputElement.getAttribute("data-useraffle");
		const lang = htmlElement.getAttribute("lang") || "da";

		const apiUrl =
			"/api/search/GetTopQuestions?pageId=" +
			encodeURIComponent(pageId || "") +
			"&lang=" +
			encodeURIComponent(lang) +
			"&useRaffle=" +
			encodeURIComponent(useraffle || "False");

		fetch(apiUrl, {
			method: "GET",
		})
			.then((response) => response.json())
			.then((data) => {
				if (!data?.questions?.length) return;
				const topQuestionsMarkup = generateTopquestionsMarkup(
					data,
					autocompleteId,
				);
				addSuggestionsMarkup(inputElement, topQuestionsMarkup);
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}

	function escapeHtml(str) {
		return String(str)
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#039;");
	}
}

export default autosuggestions;
